import {Entity} from '../core/entity/core.base.entity';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountEntity} from './account.entity';
import {ClusterEntity} from './cluster.entity';
import {SystemEntity} from './system.entity';
import {Column} from '../core/entity/core.entity.column';
import {EnvironmentKind} from '../enum/environment.kind';

@EntityTable('cluster_system', 'e6e45f84-ec3a-4e1c-a4de-abe3a7a9af59')
export class ClusterSystemEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, ClusterEntity, false, false, FieldRelationKind.BELONGS_TO, 'cluster')
    public clusterId: string;

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

}
